import { ReactElement } from "react"
import { AddressPresenter } from "./AddressPresenter"
import { createEmptyAddress } from "@/helper/transportOrderHelper"
import { FormattedMessage } from "react-intl"
import { Contact, CurrentTransportLegParty, TimeWindow } from "@/model/transportorder/transportOrder"
import { ContactPresenter } from "./ContactPresenter"
import { ReadOnlyDetailViewFormValue } from "../Form/ReadOnlyDetailViewFormValue"
import { TimeWindowPresenter } from "./timewindow/TimeWindowPresenter"

export interface TransportLegLocationPresenterProps {
    type:  "DEPARTURE" | "ARRIVAL"
    party: CurrentTransportLegParty
    timeWindow?: TimeWindow
    locationDetails?: string
    contact?: Contact
    accessCode?: string
}

export const TransportLegLocationPresenter = (props: TransportLegLocationPresenterProps): ReactElement => {
    const { type, party, timeWindow, locationDetails, contact, accessCode } = props
    const timeWindowFromLabel = `transportOrder.shipment.timewindow.from${type === "ARRIVAL" ? ".estimated" : ""}`
    const timeWindowToLabel = `transportOrder.shipment.timewindow.to${type === "ARRIVAL" ? ".estimated" : ""}`
    const locationLabel = `transportOrder.shipment.address.addition.${type === "DEPARTURE" ? "loading" : "unloading"}`
    return (
        <>
            <div className="row form-group">
                <TimeWindowPresenter
                    value={timeWindow}
                    labelFrom={<FormattedMessage id={timeWindowFromLabel}/>}
                    labelTo={<FormattedMessage id={timeWindowToLabel}/>}
                />
            </div>
            <div className="row">
                <div data-testid={"AddressInput_CompanyName"}>
                    <ReadOnlyDetailViewFormValue
                        value={party.name}
                        md={6}
                        label={<FormattedMessage id="transportOrder.shipment.company.name"/>}
                    />
                </div>
                <ReadOnlyDetailViewFormValue
                    md={6}
                    label={<FormattedMessage id={locationLabel}/>}
                    value={locationDetails}
                />
            </div>
            <AddressPresenter address={party.address || createEmptyAddress()} />
            <hr className="margin-top-20 margin-bottom-20 border-width-1 border-color-light margin-top-10-print"/>
            <div className="row">
                <div className={"col-md-6"}>
                    <ContactPresenter contact={contact}/>
                </div>
                <ReadOnlyDetailViewFormValue
                    value={accessCode}
                    md={6}
                    label={<FormattedMessage id="transportOrder.shipment.address.accessCode"/>}
                />
            </div>
        </>
    )
}
